export default {
      id: "i-like-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/sprite.svg#i-like",
      toString: function () {
        return this.url;
      }
    }